const createUploadProgressTracker = (totalFiles) => {
    let state = {
        totalFiles,
        currentStatus: '',
        decodingFileCount: 0,
        generatingPreviewImageCount: 0,
        uploadingFilesToAWSCount: 0,
    }

    const handleStatus = (status) => {
        switch (status) {
            case 'DECODING_FILE':
                state = {
                    ...state,
                    decodingFileCount: state.decodingFileCount + 1,
                    currentStatus: status,
                }
                break

            case 'GENERATING_PREVIEW_IMAGE':
                state = {
                    ...state,
                    generatingPreviewImageCount:
                        state.generatingPreviewImageCount + 1,
                }
                if (state.decodingFileCount === state.totalFiles) {
                    state = {
                        ...state,
                        currentStatus: status,
                    }
                }
                break

            case 'UPLOADING_FILE_TO_AWS':
                state = {
                    ...state,
                    uploadingFilesToAWSCount:
                        state.uploadingFilesToAWSCount + 1,
                }
                if (state.generatingPreviewImageCount === state.totalFiles) {
                    state = {
                        ...state,
                        currentStatus: status,
                    }
                }
                break

            default:
                state = {
                    ...state,
                    currentStatus: status,
                }
                break
        }

        return state.currentStatus
    }

    return {
        handleStatus,
        getState: () => state,
    }
}

export default createUploadProgressTracker
